/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as restaurantLayoutRouteImport } from './routes/restaurant/_Layout'
import { Route as adminLayoutRouteImport } from './routes/admin/_Layout'
import { Route as RootRedirectPageRouteImport } from './routes/RootRedirectPage'
import { Route as restaurantRestaurantCachedQueriesRouteImport } from './routes/restaurant/RestaurantCachedQueries'
import { Route as MenuVersionRouteImport } from './routes/MenuVersion'
import { Route as adminRestaurantListPageRouteImport } from './routes/admin/RestaurantListPage'
import { Route as adminNoticeListPageRouteImport } from './routes/admin/NoticeListPage'
import { Route as adminDocMigrationListPageRouteImport } from './routes/admin/DocMigrationListPage'
import { Route as adminDocErrorListPageRouteImport } from './routes/admin/DocErrorListPage'
import { Route as adminConversationsConversationsLayoutRouteImport } from './routes/admin/conversations/ConversationsLayout'
import { Route as adminAppStoreUpdateListPageRouteImport } from './routes/admin/AppStoreUpdateListPage'
import { Route as restaurantRestaurantSelectorRouteImport } from './routes/restaurant/RestaurantSelector'
import { Route as adminDashboardRouteImport } from './routes/admin/Dashboard'
import { Route as restaurantSettingsLayoutRouteImport } from './routes/restaurant/settings/_Layout'
import { Route as restaurantRegisterClosuresPageRouteImport } from './routes/restaurant/RegisterClosuresPage'
import { Route as restaurantPrintJobsPrintJobsPageRouteImport } from './routes/restaurant/print-jobs/PrintJobsPage'
import { Route as restaurantMenuLayoutRouteImport } from './routes/restaurant/menu/_Layout'
import { Route as restaurantDayReportsPageRouteImport } from './routes/restaurant/DayReportsPage'
import { Route as adminWorkflowDetailsPageRouteImport } from './routes/admin/WorkflowDetailsPage'
import { Route as adminRemoteCommandDetailsPageRouteImport } from './routes/admin/RemoteCommandDetailsPage'
import { Route as adminPushNotificationDetailsPageRouteImport } from './routes/admin/PushNotificationDetailsPage'
import { Route as adminOrderDetailsPageRouteImport } from './routes/admin/OrderDetailsPage'
import { Route as adminIpadsIPadDetailsPageRouteImport } from './routes/admin/ipads/IPadDetailsPage'
import { Route as adminConversationsConversationDetailsPageRouteImport } from './routes/admin/conversations/ConversationDetailsPage'
import { Route as adminArticlesArticleEditPageRouteImport } from './routes/admin/articles/ArticleEditPage'
import { Route as adminWorkflowListPageRouteImport } from './routes/admin/WorkflowListPage'
import { Route as adminStandalonePrintersStandalonePrintersPageRouteImport } from './routes/admin/standalone-printers/StandalonePrintersPage'
import { Route as adminRemoteCommandListPageRouteImport } from './routes/admin/RemoteCommandListPage'
import { Route as adminPushNotificationListPageRouteImport } from './routes/admin/PushNotificationListPage'
import { Route as adminOrderListPageRouteImport } from './routes/admin/OrderListPage'
import { Route as adminIpadsIPadListPageRouteImport } from './routes/admin/ipads/IPadListPage'
import { Route as adminConversationsConversationListPageRouteImport } from './routes/admin/conversations/ConversationListPage'
import { Route as adminArticlesArticleListPageRouteImport } from './routes/admin/articles/ArticleListPage'
import { Route as restaurantSettingsWebsiteConfigPageRouteImport } from './routes/restaurant/settings/WebsiteConfigPage'
import { Route as restaurantSettingsUserListPageRouteImport } from './routes/restaurant/settings/UserListPage'
import { Route as restaurantSettingsStripePageRouteImport } from './routes/restaurant/settings/StripePage'
import { Route as restaurantSettingsServiceHoursPageRouteImport } from './routes/restaurant/settings/ServiceHoursPage'
import { Route as restaurantSettingsPosPrintersPosPrintersSettingsPageRouteImport } from './routes/restaurant/settings/pos-printers/PosPrintersSettingsPage'
import { Route as restaurantSettingsPosPasscodesPosPasscodesPageRouteImport } from './routes/restaurant/settings/pos-passcodes/PosPasscodesPage'
import { Route as restaurantSettingsPlatformSettingsPlatformSettingsPageRouteImport } from './routes/restaurant/settings/platform-settings/PlatformSettingsPage'
import { Route as restaurantSettingsPaymentSettingsPageRouteImport } from './routes/restaurant/settings/PaymentSettingsPage'
import { Route as restaurantSettingsMobileAppConfigPageRouteImport } from './routes/restaurant/settings/MobileAppConfigPage'
import { Route as restaurantSettingsLoyaltyCardPageRouteImport } from './routes/restaurant/settings/LoyaltyCardPage'
import { Route as restaurantSettingsGeneralSettingsPageRouteImport } from './routes/restaurant/settings/GeneralSettingsPage'
import { Route as restaurantSettingsFloorPlansFloorPlansPageRouteImport } from './routes/restaurant/settings/floor-plans/FloorPlansPage'
import { Route as restaurantSettingsFeatureFlagsPageRouteImport } from './routes/restaurant/settings/FeatureFlagsPage'
import { Route as restaurantSettingsDiscountCodesDiscountCodesPageRouteImport } from './routes/restaurant/settings/discount-codes/DiscountCodesPage'
import { Route as restaurantSettingsDeliveryPageRouteImport } from './routes/restaurant/settings/DeliveryPage'
import { Route as restaurantSettingsAppStoreLinksPageRouteImport } from './routes/restaurant/settings/AppStoreLinksPage'
import { Route as restaurantOrdersOrderDetailsPageRouteImport } from './routes/restaurant/orders/OrderDetailsPage'
import { Route as restaurantMenuOverviewPageRouteImport } from './routes/restaurant/menu/OverviewPage'
import { Route as restaurantMenuModifierListPageRouteImport } from './routes/restaurant/menu/ModifierListPage'
import { Route as restaurantMenuMenuItemListPageRouteImport } from './routes/restaurant/menu/MenuItemListPage'
import { Route as restaurantMenuCategoryListPageRouteImport } from './routes/restaurant/menu/CategoryListPage'
import { Route as restaurantCustomerDetailsPageRouteImport } from './routes/restaurant/CustomerDetailsPage'
import { Route as adminStandalonePrintersEmulatorPageRouteImport } from './routes/admin/standalone-printers/EmulatorPage'
import { Route as adminLinklyLinklySessionDetailsPageRouteImport } from './routes/admin/linkly/LinklySessionDetailsPage'
import { Route as adminLinklyLinklyRequestDetailsPageRouteImport } from './routes/admin/linkly/LinklyRequestDetailsPage'
import { Route as restaurantOrdersOrderListPageRouteImport } from './routes/restaurant/orders/OrderListPage'
import { Route as restaurantCustomerListPageRouteImport } from './routes/restaurant/CustomerListPage'
import { Route as adminLinklyLinklyDeviceListPageRouteImport } from './routes/admin/linkly/LinklyDeviceListPage'
import { Route as restaurantSettingsIpadsIPadDetailsPageRouteImport } from './routes/restaurant/settings/ipads/IPadDetailsPage'
import { Route as restaurantMenuMenuVersionListPageRouteImport } from './routes/restaurant/menu/MenuVersionListPage'
import { Route as adminLinklyVirtualPinPadRouteImport } from './routes/admin/linkly/VirtualPinPad'
import { Route as restaurantSettingsIpadsIPadsPageRouteImport } from './routes/restaurant/settings/ipads/IPadsPage'
import { Route as adminLinklyLinklyDeviceDetailsPageRouteImport } from './routes/admin/linkly/LinklyDeviceDetailsPage'

const restaurantLayoutRoute = restaurantLayoutRouteImport.update({
  id: '/r',
  path: '/r',
  getParentRoute: () => rootRouteImport,
} as any)
const adminLayoutRoute = adminLayoutRouteImport.update({
  id: '/a',
  path: '/a',
  getParentRoute: () => rootRouteImport,
} as any)
const RootRedirectPageRoute = RootRedirectPageRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const restaurantRestaurantCachedQueriesRoute =
  restaurantRestaurantCachedQueriesRouteImport.update({
    id: '/$restaurantId',
    path: '/$restaurantId',
    getParentRoute: () => restaurantLayoutRoute,
  } as any)
const MenuVersionRoute = MenuVersionRouteImport.update({
  id: '/menu-versions/$menuVersionId',
  path: '/menu-versions/$menuVersionId',
  getParentRoute: () => rootRouteImport,
} as any)
const adminRestaurantListPageRoute = adminRestaurantListPageRouteImport.update({
  id: '/restaurants',
  path: '/restaurants',
  getParentRoute: () => adminLayoutRoute,
} as any)
const adminNoticeListPageRoute = adminNoticeListPageRouteImport.update({
  id: '/notices',
  path: '/notices',
  getParentRoute: () => adminLayoutRoute,
} as any)
const adminDocMigrationListPageRoute =
  adminDocMigrationListPageRouteImport.update({
    id: '/doc-migrations',
    path: '/doc-migrations',
    getParentRoute: () => adminLayoutRoute,
  } as any)
const adminDocErrorListPageRoute = adminDocErrorListPageRouteImport.update({
  id: '/doc-errors',
  path: '/doc-errors',
  getParentRoute: () => adminLayoutRoute,
} as any)
const adminConversationsConversationsLayoutRoute =
  adminConversationsConversationsLayoutRouteImport.update({
    id: '/conversations',
    path: '/conversations',
    getParentRoute: () => adminLayoutRoute,
  } as any)
const adminAppStoreUpdateListPageRoute =
  adminAppStoreUpdateListPageRouteImport.update({
    id: '/app-store-updates',
    path: '/app-store-updates',
    getParentRoute: () => adminLayoutRoute,
  } as any)
const restaurantRestaurantSelectorRoute =
  restaurantRestaurantSelectorRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => restaurantLayoutRoute,
  } as any)
const adminDashboardRoute = adminDashboardRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => adminLayoutRoute,
} as any)
const restaurantSettingsLayoutRoute =
  restaurantSettingsLayoutRouteImport.update({
    id: '/s',
    path: '/s',
    getParentRoute: () => restaurantRestaurantCachedQueriesRoute,
  } as any)
const restaurantRegisterClosuresPageRoute =
  restaurantRegisterClosuresPageRouteImport.update({
    id: '/register-closures',
    path: '/register-closures',
    getParentRoute: () => restaurantRestaurantCachedQueriesRoute,
  } as any)
const restaurantPrintJobsPrintJobsPageRoute =
  restaurantPrintJobsPrintJobsPageRouteImport.update({
    id: '/print-jobs',
    path: '/print-jobs',
    getParentRoute: () => restaurantRestaurantCachedQueriesRoute,
  } as any)
const restaurantMenuLayoutRoute = restaurantMenuLayoutRouteImport.update({
  id: '/menu',
  path: '/menu',
  getParentRoute: () => restaurantRestaurantCachedQueriesRoute,
} as any)
const restaurantDayReportsPageRoute =
  restaurantDayReportsPageRouteImport.update({
    id: '/day-reports',
    path: '/day-reports',
    getParentRoute: () => restaurantRestaurantCachedQueriesRoute,
  } as any)
const adminWorkflowDetailsPageRoute =
  adminWorkflowDetailsPageRouteImport.update({
    id: '/workflows/$workflowId',
    path: '/workflows/$workflowId',
    getParentRoute: () => adminLayoutRoute,
  } as any)
const adminRemoteCommandDetailsPageRoute =
  adminRemoteCommandDetailsPageRouteImport.update({
    id: '/remote-commands/$commandId',
    path: '/remote-commands/$commandId',
    getParentRoute: () => adminLayoutRoute,
  } as any)
const adminPushNotificationDetailsPageRoute =
  adminPushNotificationDetailsPageRouteImport.update({
    id: '/push-notifications/$notificationId',
    path: '/push-notifications/$notificationId',
    getParentRoute: () => adminLayoutRoute,
  } as any)
const adminOrderDetailsPageRoute = adminOrderDetailsPageRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => adminLayoutRoute,
} as any)
const adminIpadsIPadDetailsPageRoute =
  adminIpadsIPadDetailsPageRouteImport.update({
    id: '/ipads/$deviceId',
    path: '/ipads/$deviceId',
    getParentRoute: () => adminLayoutRoute,
  } as any)
const adminConversationsConversationDetailsPageRoute =
  adminConversationsConversationDetailsPageRouteImport.update({
    id: '/$conversationId',
    path: '/$conversationId',
    getParentRoute: () => adminConversationsConversationsLayoutRoute,
  } as any)
const adminArticlesArticleEditPageRoute =
  adminArticlesArticleEditPageRouteImport.update({
    id: '/articles/$articleId',
    path: '/articles/$articleId',
    getParentRoute: () => adminLayoutRoute,
  } as any)
const adminWorkflowListPageRoute = adminWorkflowListPageRouteImport.update({
  id: '/workflows/',
  path: '/workflows/',
  getParentRoute: () => adminLayoutRoute,
} as any)
const adminStandalonePrintersStandalonePrintersPageRoute =
  adminStandalonePrintersStandalonePrintersPageRouteImport.update({
    id: '/standalone-printers/',
    path: '/standalone-printers/',
    getParentRoute: () => adminLayoutRoute,
  } as any)
const adminRemoteCommandListPageRoute =
  adminRemoteCommandListPageRouteImport.update({
    id: '/remote-commands/',
    path: '/remote-commands/',
    getParentRoute: () => adminLayoutRoute,
  } as any)
const adminPushNotificationListPageRoute =
  adminPushNotificationListPageRouteImport.update({
    id: '/push-notifications/',
    path: '/push-notifications/',
    getParentRoute: () => adminLayoutRoute,
  } as any)
const adminOrderListPageRoute = adminOrderListPageRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => adminLayoutRoute,
} as any)
const adminIpadsIPadListPageRoute = adminIpadsIPadListPageRouteImport.update({
  id: '/ipads/',
  path: '/ipads/',
  getParentRoute: () => adminLayoutRoute,
} as any)
const adminConversationsConversationListPageRoute =
  adminConversationsConversationListPageRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => adminConversationsConversationsLayoutRoute,
  } as any)
const adminArticlesArticleListPageRoute =
  adminArticlesArticleListPageRouteImport.update({
    id: '/articles/',
    path: '/articles/',
    getParentRoute: () => adminLayoutRoute,
  } as any)
const restaurantSettingsWebsiteConfigPageRoute =
  restaurantSettingsWebsiteConfigPageRouteImport.update({
    id: '/website-config',
    path: '/website-config',
    getParentRoute: () => restaurantSettingsLayoutRoute,
  } as any)
const restaurantSettingsUserListPageRoute =
  restaurantSettingsUserListPageRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => restaurantSettingsLayoutRoute,
  } as any)
const restaurantSettingsStripePageRoute =
  restaurantSettingsStripePageRouteImport.update({
    id: '/stripe',
    path: '/stripe',
    getParentRoute: () => restaurantSettingsLayoutRoute,
  } as any)
const restaurantSettingsServiceHoursPageRoute =
  restaurantSettingsServiceHoursPageRouteImport.update({
    id: '/service-hours',
    path: '/service-hours',
    getParentRoute: () => restaurantSettingsLayoutRoute,
  } as any)
const restaurantSettingsPosPrintersPosPrintersSettingsPageRoute =
  restaurantSettingsPosPrintersPosPrintersSettingsPageRouteImport.update({
    id: '/pos-printers',
    path: '/pos-printers',
    getParentRoute: () => restaurantSettingsLayoutRoute,
  } as any)
const restaurantSettingsPosPasscodesPosPasscodesPageRoute =
  restaurantSettingsPosPasscodesPosPasscodesPageRouteImport.update({
    id: '/pos-passcodes',
    path: '/pos-passcodes',
    getParentRoute: () => restaurantSettingsLayoutRoute,
  } as any)
const restaurantSettingsPlatformSettingsPlatformSettingsPageRoute =
  restaurantSettingsPlatformSettingsPlatformSettingsPageRouteImport.update({
    id: '/platform-settings',
    path: '/platform-settings',
    getParentRoute: () => restaurantSettingsLayoutRoute,
  } as any)
const restaurantSettingsPaymentSettingsPageRoute =
  restaurantSettingsPaymentSettingsPageRouteImport.update({
    id: '/payment-settings',
    path: '/payment-settings',
    getParentRoute: () => restaurantSettingsLayoutRoute,
  } as any)
const restaurantSettingsMobileAppConfigPageRoute =
  restaurantSettingsMobileAppConfigPageRouteImport.update({
    id: '/mobile-app-config',
    path: '/mobile-app-config',
    getParentRoute: () => restaurantSettingsLayoutRoute,
  } as any)
const restaurantSettingsLoyaltyCardPageRoute =
  restaurantSettingsLoyaltyCardPageRouteImport.update({
    id: '/loyalty-card',
    path: '/loyalty-card',
    getParentRoute: () => restaurantSettingsLayoutRoute,
  } as any)
const restaurantSettingsGeneralSettingsPageRoute =
  restaurantSettingsGeneralSettingsPageRouteImport.update({
    id: '/general-settings',
    path: '/general-settings',
    getParentRoute: () => restaurantSettingsLayoutRoute,
  } as any)
const restaurantSettingsFloorPlansFloorPlansPageRoute =
  restaurantSettingsFloorPlansFloorPlansPageRouteImport.update({
    id: '/floor-plans',
    path: '/floor-plans',
    getParentRoute: () => restaurantSettingsLayoutRoute,
  } as any)
const restaurantSettingsFeatureFlagsPageRoute =
  restaurantSettingsFeatureFlagsPageRouteImport.update({
    id: '/feature-flags',
    path: '/feature-flags',
    getParentRoute: () => restaurantSettingsLayoutRoute,
  } as any)
const restaurantSettingsDiscountCodesDiscountCodesPageRoute =
  restaurantSettingsDiscountCodesDiscountCodesPageRouteImport.update({
    id: '/discount-codes',
    path: '/discount-codes',
    getParentRoute: () => restaurantSettingsLayoutRoute,
  } as any)
const restaurantSettingsDeliveryPageRoute =
  restaurantSettingsDeliveryPageRouteImport.update({
    id: '/delivery',
    path: '/delivery',
    getParentRoute: () => restaurantSettingsLayoutRoute,
  } as any)
const restaurantSettingsAppStoreLinksPageRoute =
  restaurantSettingsAppStoreLinksPageRouteImport.update({
    id: '/app-store-links',
    path: '/app-store-links',
    getParentRoute: () => restaurantSettingsLayoutRoute,
  } as any)
const restaurantOrdersOrderDetailsPageRoute =
  restaurantOrdersOrderDetailsPageRouteImport.update({
    id: '/orders/$orderId',
    path: '/orders/$orderId',
    getParentRoute: () => restaurantRestaurantCachedQueriesRoute,
  } as any)
const restaurantMenuOverviewPageRoute =
  restaurantMenuOverviewPageRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => restaurantMenuLayoutRoute,
  } as any)
const restaurantMenuModifierListPageRoute =
  restaurantMenuModifierListPageRouteImport.update({
    id: '/modifiers',
    path: '/modifiers',
    getParentRoute: () => restaurantMenuLayoutRoute,
  } as any)
const restaurantMenuMenuItemListPageRoute =
  restaurantMenuMenuItemListPageRouteImport.update({
    id: '/menu-items',
    path: '/menu-items',
    getParentRoute: () => restaurantMenuLayoutRoute,
  } as any)
const restaurantMenuCategoryListPageRoute =
  restaurantMenuCategoryListPageRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => restaurantMenuLayoutRoute,
  } as any)
const restaurantCustomerDetailsPageRoute =
  restaurantCustomerDetailsPageRouteImport.update({
    id: '/customers/$customerId',
    path: '/customers/$customerId',
    getParentRoute: () => restaurantRestaurantCachedQueriesRoute,
  } as any)
const adminStandalonePrintersEmulatorPageRoute =
  adminStandalonePrintersEmulatorPageRouteImport.update({
    id: '/standalone-printers/$imei/emulator',
    path: '/standalone-printers/$imei/emulator',
    getParentRoute: () => adminLayoutRoute,
  } as any)
const adminLinklyLinklySessionDetailsPageRoute =
  adminLinklyLinklySessionDetailsPageRouteImport.update({
    id: '/linkly/sessions/$sessionUuid',
    path: '/linkly/sessions/$sessionUuid',
    getParentRoute: () => adminLayoutRoute,
  } as any)
const adminLinklyLinklyRequestDetailsPageRoute =
  adminLinklyLinklyRequestDetailsPageRouteImport.update({
    id: '/linkly/requests/$id',
    path: '/linkly/requests/$id',
    getParentRoute: () => adminLayoutRoute,
  } as any)
const restaurantOrdersOrderListPageRoute =
  restaurantOrdersOrderListPageRouteImport.update({
    id: '/orders/',
    path: '/orders/',
    getParentRoute: () => restaurantRestaurantCachedQueriesRoute,
  } as any)
const restaurantCustomerListPageRoute =
  restaurantCustomerListPageRouteImport.update({
    id: '/customers/',
    path: '/customers/',
    getParentRoute: () => restaurantRestaurantCachedQueriesRoute,
  } as any)
const adminLinklyLinklyDeviceListPageRoute =
  adminLinklyLinklyDeviceListPageRouteImport.update({
    id: '/linkly/devices/',
    path: '/linkly/devices/',
    getParentRoute: () => adminLayoutRoute,
  } as any)
const restaurantSettingsIpadsIPadDetailsPageRoute =
  restaurantSettingsIpadsIPadDetailsPageRouteImport.update({
    id: '/ipads/$deviceId',
    path: '/ipads/$deviceId',
    getParentRoute: () => restaurantSettingsLayoutRoute,
  } as any)
const restaurantMenuMenuVersionListPageRoute =
  restaurantMenuMenuVersionListPageRouteImport.update({
    id: '/$menuId/versions',
    path: '/$menuId/versions',
    getParentRoute: () => restaurantMenuLayoutRoute,
  } as any)
const adminLinklyVirtualPinPadRoute =
  adminLinklyVirtualPinPadRouteImport.update({
    id: '/linkly/devices/$id/virtual-pin-pad',
    path: '/linkly/devices/$id/virtual-pin-pad',
    getParentRoute: () => adminLayoutRoute,
  } as any)
const restaurantSettingsIpadsIPadsPageRoute =
  restaurantSettingsIpadsIPadsPageRouteImport.update({
    id: '/ipads/',
    path: '/ipads/',
    getParentRoute: () => restaurantSettingsLayoutRoute,
  } as any)
const adminLinklyLinklyDeviceDetailsPageRoute =
  adminLinklyLinklyDeviceDetailsPageRouteImport.update({
    id: '/linkly/devices/$id/',
    path: '/linkly/devices/$id/',
    getParentRoute: () => adminLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof RootRedirectPageRoute
  '/a': typeof adminLayoutRouteWithChildren
  '/r': typeof restaurantLayoutRouteWithChildren
  '/a/': typeof adminDashboardRoute
  '/r/': typeof restaurantRestaurantSelectorRoute
  '/a/app-store-updates': typeof adminAppStoreUpdateListPageRoute
  '/a/conversations': typeof adminConversationsConversationsLayoutRouteWithChildren
  '/a/doc-errors': typeof adminDocErrorListPageRoute
  '/a/doc-migrations': typeof adminDocMigrationListPageRoute
  '/a/notices': typeof adminNoticeListPageRoute
  '/a/restaurants': typeof adminRestaurantListPageRoute
  '/menu-versions/$menuVersionId': typeof MenuVersionRoute
  '/r/$restaurantId': typeof restaurantRestaurantCachedQueriesRouteWithChildren
  '/a/articles/': typeof adminArticlesArticleListPageRoute
  '/a/conversations/': typeof adminConversationsConversationListPageRoute
  '/a/ipads/': typeof adminIpadsIPadListPageRoute
  '/a/orders/': typeof adminOrderListPageRoute
  '/a/push-notifications/': typeof adminPushNotificationListPageRoute
  '/a/remote-commands/': typeof adminRemoteCommandListPageRoute
  '/a/standalone-printers/': typeof adminStandalonePrintersStandalonePrintersPageRoute
  '/a/workflows/': typeof adminWorkflowListPageRoute
  '/a/articles/$articleId': typeof adminArticlesArticleEditPageRoute
  '/a/conversations/$conversationId': typeof adminConversationsConversationDetailsPageRoute
  '/a/ipads/$deviceId': typeof adminIpadsIPadDetailsPageRoute
  '/a/orders/$orderId': typeof adminOrderDetailsPageRoute
  '/a/push-notifications/$notificationId': typeof adminPushNotificationDetailsPageRoute
  '/a/remote-commands/$commandId': typeof adminRemoteCommandDetailsPageRoute
  '/a/workflows/$workflowId': typeof adminWorkflowDetailsPageRoute
  '/r/$restaurantId/day-reports': typeof restaurantDayReportsPageRoute
  '/r/$restaurantId/menu': typeof restaurantMenuLayoutRouteWithChildren
  '/r/$restaurantId/print-jobs': typeof restaurantPrintJobsPrintJobsPageRoute
  '/r/$restaurantId/register-closures': typeof restaurantRegisterClosuresPageRoute
  '/r/$restaurantId/s': typeof restaurantSettingsLayoutRouteWithChildren
  '/a/linkly/devices/': typeof adminLinklyLinklyDeviceListPageRoute
  '/r/$restaurantId/customers/': typeof restaurantCustomerListPageRoute
  '/r/$restaurantId/orders/': typeof restaurantOrdersOrderListPageRoute
  '/a/linkly/requests/$id': typeof adminLinklyLinklyRequestDetailsPageRoute
  '/a/linkly/sessions/$sessionUuid': typeof adminLinklyLinklySessionDetailsPageRoute
  '/a/standalone-printers/$imei/emulator': typeof adminStandalonePrintersEmulatorPageRoute
  '/r/$restaurantId/customers/$customerId': typeof restaurantCustomerDetailsPageRoute
  '/r/$restaurantId/menu/categories': typeof restaurantMenuCategoryListPageRoute
  '/r/$restaurantId/menu/menu-items': typeof restaurantMenuMenuItemListPageRoute
  '/r/$restaurantId/menu/modifiers': typeof restaurantMenuModifierListPageRoute
  '/r/$restaurantId/menu/overview': typeof restaurantMenuOverviewPageRoute
  '/r/$restaurantId/orders/$orderId': typeof restaurantOrdersOrderDetailsPageRoute
  '/r/$restaurantId/s/app-store-links': typeof restaurantSettingsAppStoreLinksPageRoute
  '/r/$restaurantId/s/delivery': typeof restaurantSettingsDeliveryPageRoute
  '/r/$restaurantId/s/discount-codes': typeof restaurantSettingsDiscountCodesDiscountCodesPageRoute
  '/r/$restaurantId/s/feature-flags': typeof restaurantSettingsFeatureFlagsPageRoute
  '/r/$restaurantId/s/floor-plans': typeof restaurantSettingsFloorPlansFloorPlansPageRoute
  '/r/$restaurantId/s/general-settings': typeof restaurantSettingsGeneralSettingsPageRoute
  '/r/$restaurantId/s/loyalty-card': typeof restaurantSettingsLoyaltyCardPageRoute
  '/r/$restaurantId/s/mobile-app-config': typeof restaurantSettingsMobileAppConfigPageRoute
  '/r/$restaurantId/s/payment-settings': typeof restaurantSettingsPaymentSettingsPageRoute
  '/r/$restaurantId/s/platform-settings': typeof restaurantSettingsPlatformSettingsPlatformSettingsPageRoute
  '/r/$restaurantId/s/pos-passcodes': typeof restaurantSettingsPosPasscodesPosPasscodesPageRoute
  '/r/$restaurantId/s/pos-printers': typeof restaurantSettingsPosPrintersPosPrintersSettingsPageRoute
  '/r/$restaurantId/s/service-hours': typeof restaurantSettingsServiceHoursPageRoute
  '/r/$restaurantId/s/stripe': typeof restaurantSettingsStripePageRoute
  '/r/$restaurantId/s/users': typeof restaurantSettingsUserListPageRoute
  '/r/$restaurantId/s/website-config': typeof restaurantSettingsWebsiteConfigPageRoute
  '/a/linkly/devices/$id/': typeof adminLinklyLinklyDeviceDetailsPageRoute
  '/r/$restaurantId/s/ipads/': typeof restaurantSettingsIpadsIPadsPageRoute
  '/a/linkly/devices/$id/virtual-pin-pad': typeof adminLinklyVirtualPinPadRoute
  '/r/$restaurantId/menu/$menuId/versions': typeof restaurantMenuMenuVersionListPageRoute
  '/r/$restaurantId/s/ipads/$deviceId': typeof restaurantSettingsIpadsIPadDetailsPageRoute
}
export interface FileRoutesByTo {
  '/': typeof RootRedirectPageRoute
  '/a': typeof adminDashboardRoute
  '/r': typeof restaurantRestaurantSelectorRoute
  '/a/app-store-updates': typeof adminAppStoreUpdateListPageRoute
  '/a/doc-errors': typeof adminDocErrorListPageRoute
  '/a/doc-migrations': typeof adminDocMigrationListPageRoute
  '/a/notices': typeof adminNoticeListPageRoute
  '/a/restaurants': typeof adminRestaurantListPageRoute
  '/menu-versions/$menuVersionId': typeof MenuVersionRoute
  '/r/$restaurantId': typeof restaurantRestaurantCachedQueriesRouteWithChildren
  '/a/articles': typeof adminArticlesArticleListPageRoute
  '/a/conversations': typeof adminConversationsConversationListPageRoute
  '/a/ipads': typeof adminIpadsIPadListPageRoute
  '/a/orders': typeof adminOrderListPageRoute
  '/a/push-notifications': typeof adminPushNotificationListPageRoute
  '/a/remote-commands': typeof adminRemoteCommandListPageRoute
  '/a/standalone-printers': typeof adminStandalonePrintersStandalonePrintersPageRoute
  '/a/workflows': typeof adminWorkflowListPageRoute
  '/a/articles/$articleId': typeof adminArticlesArticleEditPageRoute
  '/a/conversations/$conversationId': typeof adminConversationsConversationDetailsPageRoute
  '/a/ipads/$deviceId': typeof adminIpadsIPadDetailsPageRoute
  '/a/orders/$orderId': typeof adminOrderDetailsPageRoute
  '/a/push-notifications/$notificationId': typeof adminPushNotificationDetailsPageRoute
  '/a/remote-commands/$commandId': typeof adminRemoteCommandDetailsPageRoute
  '/a/workflows/$workflowId': typeof adminWorkflowDetailsPageRoute
  '/r/$restaurantId/day-reports': typeof restaurantDayReportsPageRoute
  '/r/$restaurantId/menu': typeof restaurantMenuLayoutRouteWithChildren
  '/r/$restaurantId/print-jobs': typeof restaurantPrintJobsPrintJobsPageRoute
  '/r/$restaurantId/register-closures': typeof restaurantRegisterClosuresPageRoute
  '/r/$restaurantId/s': typeof restaurantSettingsLayoutRouteWithChildren
  '/a/linkly/devices': typeof adminLinklyLinklyDeviceListPageRoute
  '/r/$restaurantId/customers': typeof restaurantCustomerListPageRoute
  '/r/$restaurantId/orders': typeof restaurantOrdersOrderListPageRoute
  '/a/linkly/requests/$id': typeof adminLinklyLinklyRequestDetailsPageRoute
  '/a/linkly/sessions/$sessionUuid': typeof adminLinklyLinklySessionDetailsPageRoute
  '/a/standalone-printers/$imei/emulator': typeof adminStandalonePrintersEmulatorPageRoute
  '/r/$restaurantId/customers/$customerId': typeof restaurantCustomerDetailsPageRoute
  '/r/$restaurantId/menu/categories': typeof restaurantMenuCategoryListPageRoute
  '/r/$restaurantId/menu/menu-items': typeof restaurantMenuMenuItemListPageRoute
  '/r/$restaurantId/menu/modifiers': typeof restaurantMenuModifierListPageRoute
  '/r/$restaurantId/menu/overview': typeof restaurantMenuOverviewPageRoute
  '/r/$restaurantId/orders/$orderId': typeof restaurantOrdersOrderDetailsPageRoute
  '/r/$restaurantId/s/app-store-links': typeof restaurantSettingsAppStoreLinksPageRoute
  '/r/$restaurantId/s/delivery': typeof restaurantSettingsDeliveryPageRoute
  '/r/$restaurantId/s/discount-codes': typeof restaurantSettingsDiscountCodesDiscountCodesPageRoute
  '/r/$restaurantId/s/feature-flags': typeof restaurantSettingsFeatureFlagsPageRoute
  '/r/$restaurantId/s/floor-plans': typeof restaurantSettingsFloorPlansFloorPlansPageRoute
  '/r/$restaurantId/s/general-settings': typeof restaurantSettingsGeneralSettingsPageRoute
  '/r/$restaurantId/s/loyalty-card': typeof restaurantSettingsLoyaltyCardPageRoute
  '/r/$restaurantId/s/mobile-app-config': typeof restaurantSettingsMobileAppConfigPageRoute
  '/r/$restaurantId/s/payment-settings': typeof restaurantSettingsPaymentSettingsPageRoute
  '/r/$restaurantId/s/platform-settings': typeof restaurantSettingsPlatformSettingsPlatformSettingsPageRoute
  '/r/$restaurantId/s/pos-passcodes': typeof restaurantSettingsPosPasscodesPosPasscodesPageRoute
  '/r/$restaurantId/s/pos-printers': typeof restaurantSettingsPosPrintersPosPrintersSettingsPageRoute
  '/r/$restaurantId/s/service-hours': typeof restaurantSettingsServiceHoursPageRoute
  '/r/$restaurantId/s/stripe': typeof restaurantSettingsStripePageRoute
  '/r/$restaurantId/s/users': typeof restaurantSettingsUserListPageRoute
  '/r/$restaurantId/s/website-config': typeof restaurantSettingsWebsiteConfigPageRoute
  '/a/linkly/devices/$id': typeof adminLinklyLinklyDeviceDetailsPageRoute
  '/r/$restaurantId/s/ipads': typeof restaurantSettingsIpadsIPadsPageRoute
  '/a/linkly/devices/$id/virtual-pin-pad': typeof adminLinklyVirtualPinPadRoute
  '/r/$restaurantId/menu/$menuId/versions': typeof restaurantMenuMenuVersionListPageRoute
  '/r/$restaurantId/s/ipads/$deviceId': typeof restaurantSettingsIpadsIPadDetailsPageRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof RootRedirectPageRoute
  '/a': typeof adminLayoutRouteWithChildren
  '/r': typeof restaurantLayoutRouteWithChildren
  '/a/': typeof adminDashboardRoute
  '/r/': typeof restaurantRestaurantSelectorRoute
  '/a/app-store-updates': typeof adminAppStoreUpdateListPageRoute
  '/a/conversations': typeof adminConversationsConversationsLayoutRouteWithChildren
  '/a/doc-errors': typeof adminDocErrorListPageRoute
  '/a/doc-migrations': typeof adminDocMigrationListPageRoute
  '/a/notices': typeof adminNoticeListPageRoute
  '/a/restaurants': typeof adminRestaurantListPageRoute
  '/menu-versions/$menuVersionId': typeof MenuVersionRoute
  '/r/$restaurantId': typeof restaurantRestaurantCachedQueriesRouteWithChildren
  '/a/articles/': typeof adminArticlesArticleListPageRoute
  '/a/conversations/': typeof adminConversationsConversationListPageRoute
  '/a/ipads/': typeof adminIpadsIPadListPageRoute
  '/a/orders/': typeof adminOrderListPageRoute
  '/a/push-notifications/': typeof adminPushNotificationListPageRoute
  '/a/remote-commands/': typeof adminRemoteCommandListPageRoute
  '/a/standalone-printers/': typeof adminStandalonePrintersStandalonePrintersPageRoute
  '/a/workflows/': typeof adminWorkflowListPageRoute
  '/a/articles/$articleId': typeof adminArticlesArticleEditPageRoute
  '/a/conversations/$conversationId': typeof adminConversationsConversationDetailsPageRoute
  '/a/ipads/$deviceId': typeof adminIpadsIPadDetailsPageRoute
  '/a/orders/$orderId': typeof adminOrderDetailsPageRoute
  '/a/push-notifications/$notificationId': typeof adminPushNotificationDetailsPageRoute
  '/a/remote-commands/$commandId': typeof adminRemoteCommandDetailsPageRoute
  '/a/workflows/$workflowId': typeof adminWorkflowDetailsPageRoute
  '/r/$restaurantId/day-reports': typeof restaurantDayReportsPageRoute
  '/r/$restaurantId/menu': typeof restaurantMenuLayoutRouteWithChildren
  '/r/$restaurantId/print-jobs': typeof restaurantPrintJobsPrintJobsPageRoute
  '/r/$restaurantId/register-closures': typeof restaurantRegisterClosuresPageRoute
  '/r/$restaurantId/s': typeof restaurantSettingsLayoutRouteWithChildren
  '/a/linkly/devices/': typeof adminLinklyLinklyDeviceListPageRoute
  '/r/$restaurantId/customers/': typeof restaurantCustomerListPageRoute
  '/r/$restaurantId/orders/': typeof restaurantOrdersOrderListPageRoute
  '/a/linkly/requests/$id': typeof adminLinklyLinklyRequestDetailsPageRoute
  '/a/linkly/sessions/$sessionUuid': typeof adminLinklyLinklySessionDetailsPageRoute
  '/a/standalone-printers/$imei/emulator': typeof adminStandalonePrintersEmulatorPageRoute
  '/r/$restaurantId/customers/$customerId': typeof restaurantCustomerDetailsPageRoute
  '/r/$restaurantId/menu/categories': typeof restaurantMenuCategoryListPageRoute
  '/r/$restaurantId/menu/menu-items': typeof restaurantMenuMenuItemListPageRoute
  '/r/$restaurantId/menu/modifiers': typeof restaurantMenuModifierListPageRoute
  '/r/$restaurantId/menu/overview': typeof restaurantMenuOverviewPageRoute
  '/r/$restaurantId/orders/$orderId': typeof restaurantOrdersOrderDetailsPageRoute
  '/r/$restaurantId/s/app-store-links': typeof restaurantSettingsAppStoreLinksPageRoute
  '/r/$restaurantId/s/delivery': typeof restaurantSettingsDeliveryPageRoute
  '/r/$restaurantId/s/discount-codes': typeof restaurantSettingsDiscountCodesDiscountCodesPageRoute
  '/r/$restaurantId/s/feature-flags': typeof restaurantSettingsFeatureFlagsPageRoute
  '/r/$restaurantId/s/floor-plans': typeof restaurantSettingsFloorPlansFloorPlansPageRoute
  '/r/$restaurantId/s/general-settings': typeof restaurantSettingsGeneralSettingsPageRoute
  '/r/$restaurantId/s/loyalty-card': typeof restaurantSettingsLoyaltyCardPageRoute
  '/r/$restaurantId/s/mobile-app-config': typeof restaurantSettingsMobileAppConfigPageRoute
  '/r/$restaurantId/s/payment-settings': typeof restaurantSettingsPaymentSettingsPageRoute
  '/r/$restaurantId/s/platform-settings': typeof restaurantSettingsPlatformSettingsPlatformSettingsPageRoute
  '/r/$restaurantId/s/pos-passcodes': typeof restaurantSettingsPosPasscodesPosPasscodesPageRoute
  '/r/$restaurantId/s/pos-printers': typeof restaurantSettingsPosPrintersPosPrintersSettingsPageRoute
  '/r/$restaurantId/s/service-hours': typeof restaurantSettingsServiceHoursPageRoute
  '/r/$restaurantId/s/stripe': typeof restaurantSettingsStripePageRoute
  '/r/$restaurantId/s/users': typeof restaurantSettingsUserListPageRoute
  '/r/$restaurantId/s/website-config': typeof restaurantSettingsWebsiteConfigPageRoute
  '/a/linkly/devices/$id/': typeof adminLinklyLinklyDeviceDetailsPageRoute
  '/r/$restaurantId/s/ipads/': typeof restaurantSettingsIpadsIPadsPageRoute
  '/a/linkly/devices/$id/virtual-pin-pad': typeof adminLinklyVirtualPinPadRoute
  '/r/$restaurantId/menu/$menuId/versions': typeof restaurantMenuMenuVersionListPageRoute
  '/r/$restaurantId/s/ipads/$deviceId': typeof restaurantSettingsIpadsIPadDetailsPageRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/a'
    | '/r'
    | '/a/'
    | '/r/'
    | '/a/app-store-updates'
    | '/a/conversations'
    | '/a/doc-errors'
    | '/a/doc-migrations'
    | '/a/notices'
    | '/a/restaurants'
    | '/menu-versions/$menuVersionId'
    | '/r/$restaurantId'
    | '/a/articles/'
    | '/a/conversations/'
    | '/a/ipads/'
    | '/a/orders/'
    | '/a/push-notifications/'
    | '/a/remote-commands/'
    | '/a/standalone-printers/'
    | '/a/workflows/'
    | '/a/articles/$articleId'
    | '/a/conversations/$conversationId'
    | '/a/ipads/$deviceId'
    | '/a/orders/$orderId'
    | '/a/push-notifications/$notificationId'
    | '/a/remote-commands/$commandId'
    | '/a/workflows/$workflowId'
    | '/r/$restaurantId/day-reports'
    | '/r/$restaurantId/menu'
    | '/r/$restaurantId/print-jobs'
    | '/r/$restaurantId/register-closures'
    | '/r/$restaurantId/s'
    | '/a/linkly/devices/'
    | '/r/$restaurantId/customers/'
    | '/r/$restaurantId/orders/'
    | '/a/linkly/requests/$id'
    | '/a/linkly/sessions/$sessionUuid'
    | '/a/standalone-printers/$imei/emulator'
    | '/r/$restaurantId/customers/$customerId'
    | '/r/$restaurantId/menu/categories'
    | '/r/$restaurantId/menu/menu-items'
    | '/r/$restaurantId/menu/modifiers'
    | '/r/$restaurantId/menu/overview'
    | '/r/$restaurantId/orders/$orderId'
    | '/r/$restaurantId/s/app-store-links'
    | '/r/$restaurantId/s/delivery'
    | '/r/$restaurantId/s/discount-codes'
    | '/r/$restaurantId/s/feature-flags'
    | '/r/$restaurantId/s/floor-plans'
    | '/r/$restaurantId/s/general-settings'
    | '/r/$restaurantId/s/loyalty-card'
    | '/r/$restaurantId/s/mobile-app-config'
    | '/r/$restaurantId/s/payment-settings'
    | '/r/$restaurantId/s/platform-settings'
    | '/r/$restaurantId/s/pos-passcodes'
    | '/r/$restaurantId/s/pos-printers'
    | '/r/$restaurantId/s/service-hours'
    | '/r/$restaurantId/s/stripe'
    | '/r/$restaurantId/s/users'
    | '/r/$restaurantId/s/website-config'
    | '/a/linkly/devices/$id/'
    | '/r/$restaurantId/s/ipads/'
    | '/a/linkly/devices/$id/virtual-pin-pad'
    | '/r/$restaurantId/menu/$menuId/versions'
    | '/r/$restaurantId/s/ipads/$deviceId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/a'
    | '/r'
    | '/a/app-store-updates'
    | '/a/doc-errors'
    | '/a/doc-migrations'
    | '/a/notices'
    | '/a/restaurants'
    | '/menu-versions/$menuVersionId'
    | '/r/$restaurantId'
    | '/a/articles'
    | '/a/conversations'
    | '/a/ipads'
    | '/a/orders'
    | '/a/push-notifications'
    | '/a/remote-commands'
    | '/a/standalone-printers'
    | '/a/workflows'
    | '/a/articles/$articleId'
    | '/a/conversations/$conversationId'
    | '/a/ipads/$deviceId'
    | '/a/orders/$orderId'
    | '/a/push-notifications/$notificationId'
    | '/a/remote-commands/$commandId'
    | '/a/workflows/$workflowId'
    | '/r/$restaurantId/day-reports'
    | '/r/$restaurantId/menu'
    | '/r/$restaurantId/print-jobs'
    | '/r/$restaurantId/register-closures'
    | '/r/$restaurantId/s'
    | '/a/linkly/devices'
    | '/r/$restaurantId/customers'
    | '/r/$restaurantId/orders'
    | '/a/linkly/requests/$id'
    | '/a/linkly/sessions/$sessionUuid'
    | '/a/standalone-printers/$imei/emulator'
    | '/r/$restaurantId/customers/$customerId'
    | '/r/$restaurantId/menu/categories'
    | '/r/$restaurantId/menu/menu-items'
    | '/r/$restaurantId/menu/modifiers'
    | '/r/$restaurantId/menu/overview'
    | '/r/$restaurantId/orders/$orderId'
    | '/r/$restaurantId/s/app-store-links'
    | '/r/$restaurantId/s/delivery'
    | '/r/$restaurantId/s/discount-codes'
    | '/r/$restaurantId/s/feature-flags'
    | '/r/$restaurantId/s/floor-plans'
    | '/r/$restaurantId/s/general-settings'
    | '/r/$restaurantId/s/loyalty-card'
    | '/r/$restaurantId/s/mobile-app-config'
    | '/r/$restaurantId/s/payment-settings'
    | '/r/$restaurantId/s/platform-settings'
    | '/r/$restaurantId/s/pos-passcodes'
    | '/r/$restaurantId/s/pos-printers'
    | '/r/$restaurantId/s/service-hours'
    | '/r/$restaurantId/s/stripe'
    | '/r/$restaurantId/s/users'
    | '/r/$restaurantId/s/website-config'
    | '/a/linkly/devices/$id'
    | '/r/$restaurantId/s/ipads'
    | '/a/linkly/devices/$id/virtual-pin-pad'
    | '/r/$restaurantId/menu/$menuId/versions'
    | '/r/$restaurantId/s/ipads/$deviceId'
  id:
    | '__root__'
    | '/'
    | '/a'
    | '/r'
    | '/a/'
    | '/r/'
    | '/a/app-store-updates'
    | '/a/conversations'
    | '/a/doc-errors'
    | '/a/doc-migrations'
    | '/a/notices'
    | '/a/restaurants'
    | '/menu-versions/$menuVersionId'
    | '/r/$restaurantId'
    | '/a/articles/'
    | '/a/conversations/'
    | '/a/ipads/'
    | '/a/orders/'
    | '/a/push-notifications/'
    | '/a/remote-commands/'
    | '/a/standalone-printers/'
    | '/a/workflows/'
    | '/a/articles/$articleId'
    | '/a/conversations/$conversationId'
    | '/a/ipads/$deviceId'
    | '/a/orders/$orderId'
    | '/a/push-notifications/$notificationId'
    | '/a/remote-commands/$commandId'
    | '/a/workflows/$workflowId'
    | '/r/$restaurantId/day-reports'
    | '/r/$restaurantId/menu'
    | '/r/$restaurantId/print-jobs'
    | '/r/$restaurantId/register-closures'
    | '/r/$restaurantId/s'
    | '/a/linkly/devices/'
    | '/r/$restaurantId/customers/'
    | '/r/$restaurantId/orders/'
    | '/a/linkly/requests/$id'
    | '/a/linkly/sessions/$sessionUuid'
    | '/a/standalone-printers/$imei/emulator'
    | '/r/$restaurantId/customers/$customerId'
    | '/r/$restaurantId/menu/categories'
    | '/r/$restaurantId/menu/menu-items'
    | '/r/$restaurantId/menu/modifiers'
    | '/r/$restaurantId/menu/overview'
    | '/r/$restaurantId/orders/$orderId'
    | '/r/$restaurantId/s/app-store-links'
    | '/r/$restaurantId/s/delivery'
    | '/r/$restaurantId/s/discount-codes'
    | '/r/$restaurantId/s/feature-flags'
    | '/r/$restaurantId/s/floor-plans'
    | '/r/$restaurantId/s/general-settings'
    | '/r/$restaurantId/s/loyalty-card'
    | '/r/$restaurantId/s/mobile-app-config'
    | '/r/$restaurantId/s/payment-settings'
    | '/r/$restaurantId/s/platform-settings'
    | '/r/$restaurantId/s/pos-passcodes'
    | '/r/$restaurantId/s/pos-printers'
    | '/r/$restaurantId/s/service-hours'
    | '/r/$restaurantId/s/stripe'
    | '/r/$restaurantId/s/users'
    | '/r/$restaurantId/s/website-config'
    | '/a/linkly/devices/$id/'
    | '/r/$restaurantId/s/ipads/'
    | '/a/linkly/devices/$id/virtual-pin-pad'
    | '/r/$restaurantId/menu/$menuId/versions'
    | '/r/$restaurantId/s/ipads/$deviceId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  RootRedirectPageRoute: typeof RootRedirectPageRoute
  adminLayoutRoute: typeof adminLayoutRouteWithChildren
  restaurantLayoutRoute: typeof restaurantLayoutRouteWithChildren
  MenuVersionRoute: typeof MenuVersionRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/r': {
      id: '/r'
      path: '/r'
      fullPath: '/r'
      preLoaderRoute: typeof restaurantLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/a': {
      id: '/a'
      path: '/a'
      fullPath: '/a'
      preLoaderRoute: typeof adminLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof RootRedirectPageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/r/$restaurantId': {
      id: '/r/$restaurantId'
      path: '/$restaurantId'
      fullPath: '/r/$restaurantId'
      preLoaderRoute: typeof restaurantRestaurantCachedQueriesRouteImport
      parentRoute: typeof restaurantLayoutRoute
    }
    '/menu-versions/$menuVersionId': {
      id: '/menu-versions/$menuVersionId'
      path: '/menu-versions/$menuVersionId'
      fullPath: '/menu-versions/$menuVersionId'
      preLoaderRoute: typeof MenuVersionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/a/restaurants': {
      id: '/a/restaurants'
      path: '/restaurants'
      fullPath: '/a/restaurants'
      preLoaderRoute: typeof adminRestaurantListPageRouteImport
      parentRoute: typeof adminLayoutRoute
    }
    '/a/notices': {
      id: '/a/notices'
      path: '/notices'
      fullPath: '/a/notices'
      preLoaderRoute: typeof adminNoticeListPageRouteImport
      parentRoute: typeof adminLayoutRoute
    }
    '/a/doc-migrations': {
      id: '/a/doc-migrations'
      path: '/doc-migrations'
      fullPath: '/a/doc-migrations'
      preLoaderRoute: typeof adminDocMigrationListPageRouteImport
      parentRoute: typeof adminLayoutRoute
    }
    '/a/doc-errors': {
      id: '/a/doc-errors'
      path: '/doc-errors'
      fullPath: '/a/doc-errors'
      preLoaderRoute: typeof adminDocErrorListPageRouteImport
      parentRoute: typeof adminLayoutRoute
    }
    '/a/conversations': {
      id: '/a/conversations'
      path: '/conversations'
      fullPath: '/a/conversations'
      preLoaderRoute: typeof adminConversationsConversationsLayoutRouteImport
      parentRoute: typeof adminLayoutRoute
    }
    '/a/app-store-updates': {
      id: '/a/app-store-updates'
      path: '/app-store-updates'
      fullPath: '/a/app-store-updates'
      preLoaderRoute: typeof adminAppStoreUpdateListPageRouteImport
      parentRoute: typeof adminLayoutRoute
    }
    '/r/': {
      id: '/r/'
      path: '/'
      fullPath: '/r/'
      preLoaderRoute: typeof restaurantRestaurantSelectorRouteImport
      parentRoute: typeof restaurantLayoutRoute
    }
    '/a/': {
      id: '/a/'
      path: '/'
      fullPath: '/a/'
      preLoaderRoute: typeof adminDashboardRouteImport
      parentRoute: typeof adminLayoutRoute
    }
    '/r/$restaurantId/s': {
      id: '/r/$restaurantId/s'
      path: '/s'
      fullPath: '/r/$restaurantId/s'
      preLoaderRoute: typeof restaurantSettingsLayoutRouteImport
      parentRoute: typeof restaurantRestaurantCachedQueriesRoute
    }
    '/r/$restaurantId/register-closures': {
      id: '/r/$restaurantId/register-closures'
      path: '/register-closures'
      fullPath: '/r/$restaurantId/register-closures'
      preLoaderRoute: typeof restaurantRegisterClosuresPageRouteImport
      parentRoute: typeof restaurantRestaurantCachedQueriesRoute
    }
    '/r/$restaurantId/print-jobs': {
      id: '/r/$restaurantId/print-jobs'
      path: '/print-jobs'
      fullPath: '/r/$restaurantId/print-jobs'
      preLoaderRoute: typeof restaurantPrintJobsPrintJobsPageRouteImport
      parentRoute: typeof restaurantRestaurantCachedQueriesRoute
    }
    '/r/$restaurantId/menu': {
      id: '/r/$restaurantId/menu'
      path: '/menu'
      fullPath: '/r/$restaurantId/menu'
      preLoaderRoute: typeof restaurantMenuLayoutRouteImport
      parentRoute: typeof restaurantRestaurantCachedQueriesRoute
    }
    '/r/$restaurantId/day-reports': {
      id: '/r/$restaurantId/day-reports'
      path: '/day-reports'
      fullPath: '/r/$restaurantId/day-reports'
      preLoaderRoute: typeof restaurantDayReportsPageRouteImport
      parentRoute: typeof restaurantRestaurantCachedQueriesRoute
    }
    '/a/workflows/$workflowId': {
      id: '/a/workflows/$workflowId'
      path: '/workflows/$workflowId'
      fullPath: '/a/workflows/$workflowId'
      preLoaderRoute: typeof adminWorkflowDetailsPageRouteImport
      parentRoute: typeof adminLayoutRoute
    }
    '/a/remote-commands/$commandId': {
      id: '/a/remote-commands/$commandId'
      path: '/remote-commands/$commandId'
      fullPath: '/a/remote-commands/$commandId'
      preLoaderRoute: typeof adminRemoteCommandDetailsPageRouteImport
      parentRoute: typeof adminLayoutRoute
    }
    '/a/push-notifications/$notificationId': {
      id: '/a/push-notifications/$notificationId'
      path: '/push-notifications/$notificationId'
      fullPath: '/a/push-notifications/$notificationId'
      preLoaderRoute: typeof adminPushNotificationDetailsPageRouteImport
      parentRoute: typeof adminLayoutRoute
    }
    '/a/orders/$orderId': {
      id: '/a/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/a/orders/$orderId'
      preLoaderRoute: typeof adminOrderDetailsPageRouteImport
      parentRoute: typeof adminLayoutRoute
    }
    '/a/ipads/$deviceId': {
      id: '/a/ipads/$deviceId'
      path: '/ipads/$deviceId'
      fullPath: '/a/ipads/$deviceId'
      preLoaderRoute: typeof adminIpadsIPadDetailsPageRouteImport
      parentRoute: typeof adminLayoutRoute
    }
    '/a/conversations/$conversationId': {
      id: '/a/conversations/$conversationId'
      path: '/$conversationId'
      fullPath: '/a/conversations/$conversationId'
      preLoaderRoute: typeof adminConversationsConversationDetailsPageRouteImport
      parentRoute: typeof adminConversationsConversationsLayoutRoute
    }
    '/a/articles/$articleId': {
      id: '/a/articles/$articleId'
      path: '/articles/$articleId'
      fullPath: '/a/articles/$articleId'
      preLoaderRoute: typeof adminArticlesArticleEditPageRouteImport
      parentRoute: typeof adminLayoutRoute
    }
    '/a/workflows/': {
      id: '/a/workflows/'
      path: '/workflows'
      fullPath: '/a/workflows/'
      preLoaderRoute: typeof adminWorkflowListPageRouteImport
      parentRoute: typeof adminLayoutRoute
    }
    '/a/standalone-printers/': {
      id: '/a/standalone-printers/'
      path: '/standalone-printers'
      fullPath: '/a/standalone-printers/'
      preLoaderRoute: typeof adminStandalonePrintersStandalonePrintersPageRouteImport
      parentRoute: typeof adminLayoutRoute
    }
    '/a/remote-commands/': {
      id: '/a/remote-commands/'
      path: '/remote-commands'
      fullPath: '/a/remote-commands/'
      preLoaderRoute: typeof adminRemoteCommandListPageRouteImport
      parentRoute: typeof adminLayoutRoute
    }
    '/a/push-notifications/': {
      id: '/a/push-notifications/'
      path: '/push-notifications'
      fullPath: '/a/push-notifications/'
      preLoaderRoute: typeof adminPushNotificationListPageRouteImport
      parentRoute: typeof adminLayoutRoute
    }
    '/a/orders/': {
      id: '/a/orders/'
      path: '/orders'
      fullPath: '/a/orders/'
      preLoaderRoute: typeof adminOrderListPageRouteImport
      parentRoute: typeof adminLayoutRoute
    }
    '/a/ipads/': {
      id: '/a/ipads/'
      path: '/ipads'
      fullPath: '/a/ipads/'
      preLoaderRoute: typeof adminIpadsIPadListPageRouteImport
      parentRoute: typeof adminLayoutRoute
    }
    '/a/conversations/': {
      id: '/a/conversations/'
      path: '/'
      fullPath: '/a/conversations/'
      preLoaderRoute: typeof adminConversationsConversationListPageRouteImport
      parentRoute: typeof adminConversationsConversationsLayoutRoute
    }
    '/a/articles/': {
      id: '/a/articles/'
      path: '/articles'
      fullPath: '/a/articles/'
      preLoaderRoute: typeof adminArticlesArticleListPageRouteImport
      parentRoute: typeof adminLayoutRoute
    }
    '/r/$restaurantId/s/website-config': {
      id: '/r/$restaurantId/s/website-config'
      path: '/website-config'
      fullPath: '/r/$restaurantId/s/website-config'
      preLoaderRoute: typeof restaurantSettingsWebsiteConfigPageRouteImport
      parentRoute: typeof restaurantSettingsLayoutRoute
    }
    '/r/$restaurantId/s/users': {
      id: '/r/$restaurantId/s/users'
      path: '/users'
      fullPath: '/r/$restaurantId/s/users'
      preLoaderRoute: typeof restaurantSettingsUserListPageRouteImport
      parentRoute: typeof restaurantSettingsLayoutRoute
    }
    '/r/$restaurantId/s/stripe': {
      id: '/r/$restaurantId/s/stripe'
      path: '/stripe'
      fullPath: '/r/$restaurantId/s/stripe'
      preLoaderRoute: typeof restaurantSettingsStripePageRouteImport
      parentRoute: typeof restaurantSettingsLayoutRoute
    }
    '/r/$restaurantId/s/service-hours': {
      id: '/r/$restaurantId/s/service-hours'
      path: '/service-hours'
      fullPath: '/r/$restaurantId/s/service-hours'
      preLoaderRoute: typeof restaurantSettingsServiceHoursPageRouteImport
      parentRoute: typeof restaurantSettingsLayoutRoute
    }
    '/r/$restaurantId/s/pos-printers': {
      id: '/r/$restaurantId/s/pos-printers'
      path: '/pos-printers'
      fullPath: '/r/$restaurantId/s/pos-printers'
      preLoaderRoute: typeof restaurantSettingsPosPrintersPosPrintersSettingsPageRouteImport
      parentRoute: typeof restaurantSettingsLayoutRoute
    }
    '/r/$restaurantId/s/pos-passcodes': {
      id: '/r/$restaurantId/s/pos-passcodes'
      path: '/pos-passcodes'
      fullPath: '/r/$restaurantId/s/pos-passcodes'
      preLoaderRoute: typeof restaurantSettingsPosPasscodesPosPasscodesPageRouteImport
      parentRoute: typeof restaurantSettingsLayoutRoute
    }
    '/r/$restaurantId/s/platform-settings': {
      id: '/r/$restaurantId/s/platform-settings'
      path: '/platform-settings'
      fullPath: '/r/$restaurantId/s/platform-settings'
      preLoaderRoute: typeof restaurantSettingsPlatformSettingsPlatformSettingsPageRouteImport
      parentRoute: typeof restaurantSettingsLayoutRoute
    }
    '/r/$restaurantId/s/payment-settings': {
      id: '/r/$restaurantId/s/payment-settings'
      path: '/payment-settings'
      fullPath: '/r/$restaurantId/s/payment-settings'
      preLoaderRoute: typeof restaurantSettingsPaymentSettingsPageRouteImport
      parentRoute: typeof restaurantSettingsLayoutRoute
    }
    '/r/$restaurantId/s/mobile-app-config': {
      id: '/r/$restaurantId/s/mobile-app-config'
      path: '/mobile-app-config'
      fullPath: '/r/$restaurantId/s/mobile-app-config'
      preLoaderRoute: typeof restaurantSettingsMobileAppConfigPageRouteImport
      parentRoute: typeof restaurantSettingsLayoutRoute
    }
    '/r/$restaurantId/s/loyalty-card': {
      id: '/r/$restaurantId/s/loyalty-card'
      path: '/loyalty-card'
      fullPath: '/r/$restaurantId/s/loyalty-card'
      preLoaderRoute: typeof restaurantSettingsLoyaltyCardPageRouteImport
      parentRoute: typeof restaurantSettingsLayoutRoute
    }
    '/r/$restaurantId/s/general-settings': {
      id: '/r/$restaurantId/s/general-settings'
      path: '/general-settings'
      fullPath: '/r/$restaurantId/s/general-settings'
      preLoaderRoute: typeof restaurantSettingsGeneralSettingsPageRouteImport
      parentRoute: typeof restaurantSettingsLayoutRoute
    }
    '/r/$restaurantId/s/floor-plans': {
      id: '/r/$restaurantId/s/floor-plans'
      path: '/floor-plans'
      fullPath: '/r/$restaurantId/s/floor-plans'
      preLoaderRoute: typeof restaurantSettingsFloorPlansFloorPlansPageRouteImport
      parentRoute: typeof restaurantSettingsLayoutRoute
    }
    '/r/$restaurantId/s/feature-flags': {
      id: '/r/$restaurantId/s/feature-flags'
      path: '/feature-flags'
      fullPath: '/r/$restaurantId/s/feature-flags'
      preLoaderRoute: typeof restaurantSettingsFeatureFlagsPageRouteImport
      parentRoute: typeof restaurantSettingsLayoutRoute
    }
    '/r/$restaurantId/s/discount-codes': {
      id: '/r/$restaurantId/s/discount-codes'
      path: '/discount-codes'
      fullPath: '/r/$restaurantId/s/discount-codes'
      preLoaderRoute: typeof restaurantSettingsDiscountCodesDiscountCodesPageRouteImport
      parentRoute: typeof restaurantSettingsLayoutRoute
    }
    '/r/$restaurantId/s/delivery': {
      id: '/r/$restaurantId/s/delivery'
      path: '/delivery'
      fullPath: '/r/$restaurantId/s/delivery'
      preLoaderRoute: typeof restaurantSettingsDeliveryPageRouteImport
      parentRoute: typeof restaurantSettingsLayoutRoute
    }
    '/r/$restaurantId/s/app-store-links': {
      id: '/r/$restaurantId/s/app-store-links'
      path: '/app-store-links'
      fullPath: '/r/$restaurantId/s/app-store-links'
      preLoaderRoute: typeof restaurantSettingsAppStoreLinksPageRouteImport
      parentRoute: typeof restaurantSettingsLayoutRoute
    }
    '/r/$restaurantId/orders/$orderId': {
      id: '/r/$restaurantId/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/r/$restaurantId/orders/$orderId'
      preLoaderRoute: typeof restaurantOrdersOrderDetailsPageRouteImport
      parentRoute: typeof restaurantRestaurantCachedQueriesRoute
    }
    '/r/$restaurantId/menu/overview': {
      id: '/r/$restaurantId/menu/overview'
      path: '/overview'
      fullPath: '/r/$restaurantId/menu/overview'
      preLoaderRoute: typeof restaurantMenuOverviewPageRouteImport
      parentRoute: typeof restaurantMenuLayoutRoute
    }
    '/r/$restaurantId/menu/modifiers': {
      id: '/r/$restaurantId/menu/modifiers'
      path: '/modifiers'
      fullPath: '/r/$restaurantId/menu/modifiers'
      preLoaderRoute: typeof restaurantMenuModifierListPageRouteImport
      parentRoute: typeof restaurantMenuLayoutRoute
    }
    '/r/$restaurantId/menu/menu-items': {
      id: '/r/$restaurantId/menu/menu-items'
      path: '/menu-items'
      fullPath: '/r/$restaurantId/menu/menu-items'
      preLoaderRoute: typeof restaurantMenuMenuItemListPageRouteImport
      parentRoute: typeof restaurantMenuLayoutRoute
    }
    '/r/$restaurantId/menu/categories': {
      id: '/r/$restaurantId/menu/categories'
      path: '/categories'
      fullPath: '/r/$restaurantId/menu/categories'
      preLoaderRoute: typeof restaurantMenuCategoryListPageRouteImport
      parentRoute: typeof restaurantMenuLayoutRoute
    }
    '/r/$restaurantId/customers/$customerId': {
      id: '/r/$restaurantId/customers/$customerId'
      path: '/customers/$customerId'
      fullPath: '/r/$restaurantId/customers/$customerId'
      preLoaderRoute: typeof restaurantCustomerDetailsPageRouteImport
      parentRoute: typeof restaurantRestaurantCachedQueriesRoute
    }
    '/a/standalone-printers/$imei/emulator': {
      id: '/a/standalone-printers/$imei/emulator'
      path: '/standalone-printers/$imei/emulator'
      fullPath: '/a/standalone-printers/$imei/emulator'
      preLoaderRoute: typeof adminStandalonePrintersEmulatorPageRouteImport
      parentRoute: typeof adminLayoutRoute
    }
    '/a/linkly/sessions/$sessionUuid': {
      id: '/a/linkly/sessions/$sessionUuid'
      path: '/linkly/sessions/$sessionUuid'
      fullPath: '/a/linkly/sessions/$sessionUuid'
      preLoaderRoute: typeof adminLinklyLinklySessionDetailsPageRouteImport
      parentRoute: typeof adminLayoutRoute
    }
    '/a/linkly/requests/$id': {
      id: '/a/linkly/requests/$id'
      path: '/linkly/requests/$id'
      fullPath: '/a/linkly/requests/$id'
      preLoaderRoute: typeof adminLinklyLinklyRequestDetailsPageRouteImport
      parentRoute: typeof adminLayoutRoute
    }
    '/r/$restaurantId/orders/': {
      id: '/r/$restaurantId/orders/'
      path: '/orders'
      fullPath: '/r/$restaurantId/orders/'
      preLoaderRoute: typeof restaurantOrdersOrderListPageRouteImport
      parentRoute: typeof restaurantRestaurantCachedQueriesRoute
    }
    '/r/$restaurantId/customers/': {
      id: '/r/$restaurantId/customers/'
      path: '/customers'
      fullPath: '/r/$restaurantId/customers/'
      preLoaderRoute: typeof restaurantCustomerListPageRouteImport
      parentRoute: typeof restaurantRestaurantCachedQueriesRoute
    }
    '/a/linkly/devices/': {
      id: '/a/linkly/devices/'
      path: '/linkly/devices'
      fullPath: '/a/linkly/devices/'
      preLoaderRoute: typeof adminLinklyLinklyDeviceListPageRouteImport
      parentRoute: typeof adminLayoutRoute
    }
    '/r/$restaurantId/s/ipads/$deviceId': {
      id: '/r/$restaurantId/s/ipads/$deviceId'
      path: '/ipads/$deviceId'
      fullPath: '/r/$restaurantId/s/ipads/$deviceId'
      preLoaderRoute: typeof restaurantSettingsIpadsIPadDetailsPageRouteImport
      parentRoute: typeof restaurantSettingsLayoutRoute
    }
    '/r/$restaurantId/menu/$menuId/versions': {
      id: '/r/$restaurantId/menu/$menuId/versions'
      path: '/$menuId/versions'
      fullPath: '/r/$restaurantId/menu/$menuId/versions'
      preLoaderRoute: typeof restaurantMenuMenuVersionListPageRouteImport
      parentRoute: typeof restaurantMenuLayoutRoute
    }
    '/a/linkly/devices/$id/virtual-pin-pad': {
      id: '/a/linkly/devices/$id/virtual-pin-pad'
      path: '/linkly/devices/$id/virtual-pin-pad'
      fullPath: '/a/linkly/devices/$id/virtual-pin-pad'
      preLoaderRoute: typeof adminLinklyVirtualPinPadRouteImport
      parentRoute: typeof adminLayoutRoute
    }
    '/r/$restaurantId/s/ipads/': {
      id: '/r/$restaurantId/s/ipads/'
      path: '/ipads'
      fullPath: '/r/$restaurantId/s/ipads/'
      preLoaderRoute: typeof restaurantSettingsIpadsIPadsPageRouteImport
      parentRoute: typeof restaurantSettingsLayoutRoute
    }
    '/a/linkly/devices/$id/': {
      id: '/a/linkly/devices/$id/'
      path: '/linkly/devices/$id'
      fullPath: '/a/linkly/devices/$id/'
      preLoaderRoute: typeof adminLinklyLinklyDeviceDetailsPageRouteImport
      parentRoute: typeof adminLayoutRoute
    }
  }
}

interface adminConversationsConversationsLayoutRouteChildren {
  adminConversationsConversationListPageRoute: typeof adminConversationsConversationListPageRoute
  adminConversationsConversationDetailsPageRoute: typeof adminConversationsConversationDetailsPageRoute
}

const adminConversationsConversationsLayoutRouteChildren: adminConversationsConversationsLayoutRouteChildren =
  {
    adminConversationsConversationListPageRoute:
      adminConversationsConversationListPageRoute,
    adminConversationsConversationDetailsPageRoute:
      adminConversationsConversationDetailsPageRoute,
  }

const adminConversationsConversationsLayoutRouteWithChildren =
  adminConversationsConversationsLayoutRoute._addFileChildren(
    adminConversationsConversationsLayoutRouteChildren,
  )

interface adminLayoutRouteChildren {
  adminDashboardRoute: typeof adminDashboardRoute
  adminAppStoreUpdateListPageRoute: typeof adminAppStoreUpdateListPageRoute
  adminConversationsConversationsLayoutRoute: typeof adminConversationsConversationsLayoutRouteWithChildren
  adminDocErrorListPageRoute: typeof adminDocErrorListPageRoute
  adminDocMigrationListPageRoute: typeof adminDocMigrationListPageRoute
  adminNoticeListPageRoute: typeof adminNoticeListPageRoute
  adminRestaurantListPageRoute: typeof adminRestaurantListPageRoute
  adminArticlesArticleListPageRoute: typeof adminArticlesArticleListPageRoute
  adminIpadsIPadListPageRoute: typeof adminIpadsIPadListPageRoute
  adminOrderListPageRoute: typeof adminOrderListPageRoute
  adminPushNotificationListPageRoute: typeof adminPushNotificationListPageRoute
  adminRemoteCommandListPageRoute: typeof adminRemoteCommandListPageRoute
  adminStandalonePrintersStandalonePrintersPageRoute: typeof adminStandalonePrintersStandalonePrintersPageRoute
  adminWorkflowListPageRoute: typeof adminWorkflowListPageRoute
  adminArticlesArticleEditPageRoute: typeof adminArticlesArticleEditPageRoute
  adminIpadsIPadDetailsPageRoute: typeof adminIpadsIPadDetailsPageRoute
  adminOrderDetailsPageRoute: typeof adminOrderDetailsPageRoute
  adminPushNotificationDetailsPageRoute: typeof adminPushNotificationDetailsPageRoute
  adminRemoteCommandDetailsPageRoute: typeof adminRemoteCommandDetailsPageRoute
  adminWorkflowDetailsPageRoute: typeof adminWorkflowDetailsPageRoute
  adminLinklyLinklyDeviceListPageRoute: typeof adminLinklyLinklyDeviceListPageRoute
  adminLinklyLinklyRequestDetailsPageRoute: typeof adminLinklyLinklyRequestDetailsPageRoute
  adminLinklyLinklySessionDetailsPageRoute: typeof adminLinklyLinklySessionDetailsPageRoute
  adminStandalonePrintersEmulatorPageRoute: typeof adminStandalonePrintersEmulatorPageRoute
  adminLinklyLinklyDeviceDetailsPageRoute: typeof adminLinklyLinklyDeviceDetailsPageRoute
  adminLinklyVirtualPinPadRoute: typeof adminLinklyVirtualPinPadRoute
}

const adminLayoutRouteChildren: adminLayoutRouteChildren = {
  adminDashboardRoute: adminDashboardRoute,
  adminAppStoreUpdateListPageRoute: adminAppStoreUpdateListPageRoute,
  adminConversationsConversationsLayoutRoute:
    adminConversationsConversationsLayoutRouteWithChildren,
  adminDocErrorListPageRoute: adminDocErrorListPageRoute,
  adminDocMigrationListPageRoute: adminDocMigrationListPageRoute,
  adminNoticeListPageRoute: adminNoticeListPageRoute,
  adminRestaurantListPageRoute: adminRestaurantListPageRoute,
  adminArticlesArticleListPageRoute: adminArticlesArticleListPageRoute,
  adminIpadsIPadListPageRoute: adminIpadsIPadListPageRoute,
  adminOrderListPageRoute: adminOrderListPageRoute,
  adminPushNotificationListPageRoute: adminPushNotificationListPageRoute,
  adminRemoteCommandListPageRoute: adminRemoteCommandListPageRoute,
  adminStandalonePrintersStandalonePrintersPageRoute:
    adminStandalonePrintersStandalonePrintersPageRoute,
  adminWorkflowListPageRoute: adminWorkflowListPageRoute,
  adminArticlesArticleEditPageRoute: adminArticlesArticleEditPageRoute,
  adminIpadsIPadDetailsPageRoute: adminIpadsIPadDetailsPageRoute,
  adminOrderDetailsPageRoute: adminOrderDetailsPageRoute,
  adminPushNotificationDetailsPageRoute: adminPushNotificationDetailsPageRoute,
  adminRemoteCommandDetailsPageRoute: adminRemoteCommandDetailsPageRoute,
  adminWorkflowDetailsPageRoute: adminWorkflowDetailsPageRoute,
  adminLinklyLinklyDeviceListPageRoute: adminLinklyLinklyDeviceListPageRoute,
  adminLinklyLinklyRequestDetailsPageRoute:
    adminLinklyLinklyRequestDetailsPageRoute,
  adminLinklyLinklySessionDetailsPageRoute:
    adminLinklyLinklySessionDetailsPageRoute,
  adminStandalonePrintersEmulatorPageRoute:
    adminStandalonePrintersEmulatorPageRoute,
  adminLinklyLinklyDeviceDetailsPageRoute:
    adminLinklyLinklyDeviceDetailsPageRoute,
  adminLinklyVirtualPinPadRoute: adminLinklyVirtualPinPadRoute,
}

const adminLayoutRouteWithChildren = adminLayoutRoute._addFileChildren(
  adminLayoutRouteChildren,
)

interface restaurantMenuLayoutRouteChildren {
  restaurantMenuCategoryListPageRoute: typeof restaurantMenuCategoryListPageRoute
  restaurantMenuMenuItemListPageRoute: typeof restaurantMenuMenuItemListPageRoute
  restaurantMenuModifierListPageRoute: typeof restaurantMenuModifierListPageRoute
  restaurantMenuOverviewPageRoute: typeof restaurantMenuOverviewPageRoute
  restaurantMenuMenuVersionListPageRoute: typeof restaurantMenuMenuVersionListPageRoute
}

const restaurantMenuLayoutRouteChildren: restaurantMenuLayoutRouteChildren = {
  restaurantMenuCategoryListPageRoute: restaurantMenuCategoryListPageRoute,
  restaurantMenuMenuItemListPageRoute: restaurantMenuMenuItemListPageRoute,
  restaurantMenuModifierListPageRoute: restaurantMenuModifierListPageRoute,
  restaurantMenuOverviewPageRoute: restaurantMenuOverviewPageRoute,
  restaurantMenuMenuVersionListPageRoute:
    restaurantMenuMenuVersionListPageRoute,
}

const restaurantMenuLayoutRouteWithChildren =
  restaurantMenuLayoutRoute._addFileChildren(restaurantMenuLayoutRouteChildren)

interface restaurantSettingsLayoutRouteChildren {
  restaurantSettingsAppStoreLinksPageRoute: typeof restaurantSettingsAppStoreLinksPageRoute
  restaurantSettingsDeliveryPageRoute: typeof restaurantSettingsDeliveryPageRoute
  restaurantSettingsDiscountCodesDiscountCodesPageRoute: typeof restaurantSettingsDiscountCodesDiscountCodesPageRoute
  restaurantSettingsFeatureFlagsPageRoute: typeof restaurantSettingsFeatureFlagsPageRoute
  restaurantSettingsFloorPlansFloorPlansPageRoute: typeof restaurantSettingsFloorPlansFloorPlansPageRoute
  restaurantSettingsGeneralSettingsPageRoute: typeof restaurantSettingsGeneralSettingsPageRoute
  restaurantSettingsLoyaltyCardPageRoute: typeof restaurantSettingsLoyaltyCardPageRoute
  restaurantSettingsMobileAppConfigPageRoute: typeof restaurantSettingsMobileAppConfigPageRoute
  restaurantSettingsPaymentSettingsPageRoute: typeof restaurantSettingsPaymentSettingsPageRoute
  restaurantSettingsPlatformSettingsPlatformSettingsPageRoute: typeof restaurantSettingsPlatformSettingsPlatformSettingsPageRoute
  restaurantSettingsPosPasscodesPosPasscodesPageRoute: typeof restaurantSettingsPosPasscodesPosPasscodesPageRoute
  restaurantSettingsPosPrintersPosPrintersSettingsPageRoute: typeof restaurantSettingsPosPrintersPosPrintersSettingsPageRoute
  restaurantSettingsServiceHoursPageRoute: typeof restaurantSettingsServiceHoursPageRoute
  restaurantSettingsStripePageRoute: typeof restaurantSettingsStripePageRoute
  restaurantSettingsUserListPageRoute: typeof restaurantSettingsUserListPageRoute
  restaurantSettingsWebsiteConfigPageRoute: typeof restaurantSettingsWebsiteConfigPageRoute
  restaurantSettingsIpadsIPadsPageRoute: typeof restaurantSettingsIpadsIPadsPageRoute
  restaurantSettingsIpadsIPadDetailsPageRoute: typeof restaurantSettingsIpadsIPadDetailsPageRoute
}

const restaurantSettingsLayoutRouteChildren: restaurantSettingsLayoutRouteChildren =
  {
    restaurantSettingsAppStoreLinksPageRoute:
      restaurantSettingsAppStoreLinksPageRoute,
    restaurantSettingsDeliveryPageRoute: restaurantSettingsDeliveryPageRoute,
    restaurantSettingsDiscountCodesDiscountCodesPageRoute:
      restaurantSettingsDiscountCodesDiscountCodesPageRoute,
    restaurantSettingsFeatureFlagsPageRoute:
      restaurantSettingsFeatureFlagsPageRoute,
    restaurantSettingsFloorPlansFloorPlansPageRoute:
      restaurantSettingsFloorPlansFloorPlansPageRoute,
    restaurantSettingsGeneralSettingsPageRoute:
      restaurantSettingsGeneralSettingsPageRoute,
    restaurantSettingsLoyaltyCardPageRoute:
      restaurantSettingsLoyaltyCardPageRoute,
    restaurantSettingsMobileAppConfigPageRoute:
      restaurantSettingsMobileAppConfigPageRoute,
    restaurantSettingsPaymentSettingsPageRoute:
      restaurantSettingsPaymentSettingsPageRoute,
    restaurantSettingsPlatformSettingsPlatformSettingsPageRoute:
      restaurantSettingsPlatformSettingsPlatformSettingsPageRoute,
    restaurantSettingsPosPasscodesPosPasscodesPageRoute:
      restaurantSettingsPosPasscodesPosPasscodesPageRoute,
    restaurantSettingsPosPrintersPosPrintersSettingsPageRoute:
      restaurantSettingsPosPrintersPosPrintersSettingsPageRoute,
    restaurantSettingsServiceHoursPageRoute:
      restaurantSettingsServiceHoursPageRoute,
    restaurantSettingsStripePageRoute: restaurantSettingsStripePageRoute,
    restaurantSettingsUserListPageRoute: restaurantSettingsUserListPageRoute,
    restaurantSettingsWebsiteConfigPageRoute:
      restaurantSettingsWebsiteConfigPageRoute,
    restaurantSettingsIpadsIPadsPageRoute:
      restaurantSettingsIpadsIPadsPageRoute,
    restaurantSettingsIpadsIPadDetailsPageRoute:
      restaurantSettingsIpadsIPadDetailsPageRoute,
  }

const restaurantSettingsLayoutRouteWithChildren =
  restaurantSettingsLayoutRoute._addFileChildren(
    restaurantSettingsLayoutRouteChildren,
  )

interface restaurantRestaurantCachedQueriesRouteChildren {
  restaurantDayReportsPageRoute: typeof restaurantDayReportsPageRoute
  restaurantMenuLayoutRoute: typeof restaurantMenuLayoutRouteWithChildren
  restaurantPrintJobsPrintJobsPageRoute: typeof restaurantPrintJobsPrintJobsPageRoute
  restaurantRegisterClosuresPageRoute: typeof restaurantRegisterClosuresPageRoute
  restaurantSettingsLayoutRoute: typeof restaurantSettingsLayoutRouteWithChildren
  restaurantCustomerListPageRoute: typeof restaurantCustomerListPageRoute
  restaurantOrdersOrderListPageRoute: typeof restaurantOrdersOrderListPageRoute
  restaurantCustomerDetailsPageRoute: typeof restaurantCustomerDetailsPageRoute
  restaurantOrdersOrderDetailsPageRoute: typeof restaurantOrdersOrderDetailsPageRoute
}

const restaurantRestaurantCachedQueriesRouteChildren: restaurantRestaurantCachedQueriesRouteChildren =
  {
    restaurantDayReportsPageRoute: restaurantDayReportsPageRoute,
    restaurantMenuLayoutRoute: restaurantMenuLayoutRouteWithChildren,
    restaurantPrintJobsPrintJobsPageRoute:
      restaurantPrintJobsPrintJobsPageRoute,
    restaurantRegisterClosuresPageRoute: restaurantRegisterClosuresPageRoute,
    restaurantSettingsLayoutRoute: restaurantSettingsLayoutRouteWithChildren,
    restaurantCustomerListPageRoute: restaurantCustomerListPageRoute,
    restaurantOrdersOrderListPageRoute: restaurantOrdersOrderListPageRoute,
    restaurantCustomerDetailsPageRoute: restaurantCustomerDetailsPageRoute,
    restaurantOrdersOrderDetailsPageRoute:
      restaurantOrdersOrderDetailsPageRoute,
  }

const restaurantRestaurantCachedQueriesRouteWithChildren =
  restaurantRestaurantCachedQueriesRoute._addFileChildren(
    restaurantRestaurantCachedQueriesRouteChildren,
  )

interface restaurantLayoutRouteChildren {
  restaurantRestaurantSelectorRoute: typeof restaurantRestaurantSelectorRoute
  restaurantRestaurantCachedQueriesRoute: typeof restaurantRestaurantCachedQueriesRouteWithChildren
}

const restaurantLayoutRouteChildren: restaurantLayoutRouteChildren = {
  restaurantRestaurantSelectorRoute: restaurantRestaurantSelectorRoute,
  restaurantRestaurantCachedQueriesRoute:
    restaurantRestaurantCachedQueriesRouteWithChildren,
}

const restaurantLayoutRouteWithChildren =
  restaurantLayoutRoute._addFileChildren(restaurantLayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  RootRedirectPageRoute: RootRedirectPageRoute,
  adminLayoutRoute: adminLayoutRouteWithChildren,
  restaurantLayoutRoute: restaurantLayoutRouteWithChildren,
  MenuVersionRoute: MenuVersionRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
